import React from "react";
import PropTypes from "prop-types";

import StandardTAIL from "./StandardTAIL";
import SecondaryTAIL from "./SecondaryTAIL";
import IconWallTAIL from "./IconWallTAIL";
import IconCardWallTAIL from "./IconCardWallTAIL";
import ComponentMissing from "../../Debug/ComponentMissing";

const TextAndIconListSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  iconList,
  viewportHeight,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    iconList,
    viewportHeight,
    animation,
  };

  function switchTextAndIconList() {
    switch (layout) {
      case "standard":
        return <StandardTAIL properties={properties} />;
      case "secondary":
        return <SecondaryTAIL properties={properties} />;
      case "iconWall":
        return <IconWallTAIL properties={properties} />;
      case "iconCardWall":
        return <IconCardWallTAIL properties={properties} />;
      default:
        return <ComponentMissing type="TextAndIconList" subType={layout} />;
    }
  }

  return switchTextAndIconList();
};

TextAndIconListSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  iconList: PropTypes.instanceOf(Array),
  viewportHeight: PropTypes.bool,
  animaton: PropTypes.instanceOf(Object),
};

export default TextAndIconListSwitcher;
